import { Transition, Dialog as DailogUi } from "@headlessui/react";
import React, { Fragment } from "react";
import { IoClose } from "react-icons/io5";
import InputGiftRecipientDetailsPopup from "../../gift_a_basket/InputGiftRecipientDetailsPopup";

const ChangeRecipient = ({
    openRecipientDetailsModal,
    setOpenRecipientDetailsModal,
    fetchedExistingAddress,
    basketType
}) => {
    return (
        <Transition appear show={openRecipientDetailsModal} as={Fragment}>
                    <DailogUi
                        as="div"
                        className="relative z-50"
                        onClose={() => setOpenRecipientDetailsModal(false)}
                    >
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black/25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <DailogUi.Panel className="w-full max-w-xl transform overflow-hidden rounded-xl bg-[#F9F9F9] text-left align-middle shadow-xl transition-all">
                                        <div className="scrollbar-thumb-[#1a3517] scrollbar-track-[#265426] h-full max-h-[525px] overflow-y-scroll p-2 scrollbar-thin">
                                            <div
                                                onClick={() =>
                                                    setOpenRecipientDetailsModal(
                                                        !openRecipientDetailsModal
                                                    )
                                                }
                                                className="fixed right-4 top-2 z-40 w-fit cursor-pointer rounded-full bg-[#558223] p-1.5 text-white"
                                            >
                                                <IoClose className="h-5 w-5" />
                                            </div>
                                            <InputGiftRecipientDetailsPopup
                                                setOpenRecipientDetailsModal={
                                                    setOpenRecipientDetailsModal
                                                }
                                                fetchedExistingAddress={fetchedExistingAddress}
                                                gift_type={basketType}
                                            />
                                        </div>
                                    </DailogUi.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </DailogUi>
                </Transition>
    )
}

export default ChangeRecipient;